import React, { FC } from "react";
import { Chip, Tooltip } from "@mui/material";
import { alpha } from "@mui/material/styles";

import CloseIcon from "../../icons/CloseIcon";

interface SidebarClaimFilterChipProps {
  claimNumber: string;
  isClaimFilterApplied: boolean;
  onClear: () => void;
  onReapply: () => void;
}

/** Shown below the sidebar search bar when the chat list is filtered down to
 * a single claim's chats, so the user can see which claim is active and
 * clear the filter to see all chats again. The chip stays visible after
 * clearing (unlike removing the filter outright) so clicking it again
 * re-applies the same claim's filter. */
const SidebarClaimFilterChip: FC<SidebarClaimFilterChipProps> = ({
  claimNumber,
  isClaimFilterApplied,
  onClear,
  onReapply,
}) => (
  <Tooltip
    arrow
    title={isClaimFilterApplied ? undefined : "Click to apply filter"}
  >
    <Chip
      label={`${!isClaimFilterApplied ? "Filter by: " : ""}Claim #${claimNumber}`}
      onClick={isClaimFilterApplied ? undefined : onReapply}
      onDelete={isClaimFilterApplied ? onClear : undefined}
      deleteIcon={<CloseIcon size={14} />}
      variant={!isClaimFilterApplied ? "filled" : "outlined"}
      size="small"
      sx={{
        alignSelf: "flex-start",
        borderColor: "custom.brandTeal",
        borderRadius: "6px",
        border: !isClaimFilterApplied ? "none" : undefined,
        color: "custom.brandTeal",
        bgcolor: (theme) =>
          !isClaimFilterApplied
            ? alpha(theme.palette.custom.brandTeal, 0.12)
            : theme.palette.background.paper,
        fontWeight: 600,
        fontSize: "0.8125rem",
        "& .MuiChip-deleteIcon": {
          color: "custom.brandTeal",
          "&:hover": {
            opacity: 0.7,
          },
        },
      }}
    />
  </Tooltip>
);

export default SidebarClaimFilterChip;
